<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :isVTN="isVTN",
    :isProcesso="isProcesso",
    :isImagem="isImagem"
    :tituloDocumento="tituloDocumento"
    :tipoProcesso="tipoProcesso"
    :isVisualisaProcessoDespacho="isVisualisaProcessoDespacho"
  )
  app-modal-termo-compromisso(
    v-if="showModalVisualizarTermo"
    @closeModal="closeModalVisualizarTermo"
    :isTermoAceito="true"
    :tipoPagamento="tipoPagamento"
    :dataAceiteTermo="dataAceiteTermo"
    :conteudo="conteudoModal"
    :visualizarTermo="true"
  )
  AppModalVisualizarVtnRR(
    v-if="showModalVisualizaVTN",
    @closeModal="closeModalVisualizaVTN",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :isVTN="isVTN"
  )
  AppModalVisualizarVtnAP(
    v-if="showModalVisualizaVTN",
    @closeModal="closeModalVisualizaVTN",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :isVTN="isVTN"
  )
  app-modal-lista-conversas(
    v-if="showModalConversas && conversas",
    @closeModal="closeModalConversas",
    :conversas="conversas"
  )
  app-modal-lista-solicitacoes-informacao(
    v-if="showModalSolicitacoesInformacao && solicitacoesInformacao",
    @closeModal="closeModalSolicitacoesInformacao",
    :solicitacoesInformacao="solicitacoesInformacao"
  )
  app-modal-visualizar-protesto(
    v-if="showModalProtesto"
    @closeModal="closeModalProtesto",
    :protesto="protesto"
  )
  el-collapse(v-if="data.length > 0")
    el-collapse-item(v-for="(item, indexItem) in data" :key="indexItem" :title="item.nome" @click.native="onCollapse(item, indexItem)")
      div.container-loading(v-loading="item.loading", v-if="item.loading")
      el-card(v-else v-for="(subItem, indexSubItem) in item.despachos" :key="indexSubItem")
        slot(name="header")
          h2 {{ subItem.titulo }}
        //- Anotações icones
        div.annotation(
          v-if="!visualizacao && isInserirAnotacao()"
        )
          div(@click="handleAnotacoes(indexSubItem, indexItem)", v-if="!(showAnotacao && (indexAnotacao === indexSubItem && indexCollapse === indexItem ))").icon-annotation
            el-tooltip(content="Anotação")
              font-awesome-icon(icon="comment-alt", size="lg").icon-annotation__pointer

          div(@click="handleAnotacoes(indexSubItem, indexItem)", size="6x" v-else).icon-annotation
            el-tooltip(content="Fechar anotação")
              font-awesome-icon(icon="times").icon-annotation__pointer
        div(v-if="subItem.idDespachoTitulo && subItem.tipo === 'ERRATA_TITULO'")
          a.link(@click="visualizarRetificacaoTitulo(subItem.idDespachoTitulo)") {{ errataMinuta }}
        div(v-if="subItem.idDespachoTitulo && !['ERRATA_TITULO', 'OFICIO_CCR'].includes(subItem.tipo)")
          a.link(@click="visualizarTitulo(subItem.idDespachoTitulo)") {{ tituloMinuta }}
        div(v-if="subItem.idDespachoTitulo && subItem.tipo === 'OFICIO_CCR'")
          a.link(@click="visualizarOficio()") Minuta do ofício
        div(v-if="subItem.tipo === 'VTN' && (!isRoraima && !isAmapa)")
          a.link(@click="visualizarVTN(subItem.idVTN)") Resumo da VTN
        div(v-if="subItem.tipo === 'VTN' && (!isRoraima && !isAmapa) && (subItem.formaDePagamento && subItem.formaDePagamento === 'PARCELADO')")
          a.link(@click="visualizarTermoDeCompromisso(subItem)") Termo de Compromisso
        div(v-if="subItem.tipo === 'VTN' && (isRoraima)")
          a.link(@click="visualizarVTNRR(subItem)") Resumo da VTN
        div(v-if="visualizarResumoVtnAp(subItem)")
          a.link(@click="visualizarVtnAP(subItem)") Resumo da VTN
        div(v-if="subItem.idDespachoPortaria")
          a.link(@click="visualizarPortaria(subItem.idDespachoPortaria)") Portaria
        div(v-if="subItem.idAnaliseAutomatizada")
          a.link(@click="visualizarLaudo(subItem.id)") Laudo análise automatizada
        div(v-if="subItem.idLaudo")
          a.link(@click="visualizarLaudoAutomatico(subItem.id)") Laudo análise automatizada
        div(v-if="subItem.idMapa")
          a.link(@click="visualizarMapaAutomatico(subItem.id)") Mapa análise automatizada
        div(v-if="subItem.idDocumentoGabinete")
          a.link(@click="visualizarReurb(subItem.id)") Despacho unificado REURB
        div(v-for="conteudo in subItem.conteudos")

          .container-item(v-if="conteudo.tipo === 'texto' && conteudo.texto")
            p.label
              | {{ conteudo.label.endsWith('?') ? conteudo.label : `${conteudo.label}:` }} &nbsp
            span(v-html="conteudo.texto")

          .container-item(v-if="conteudo.tipo === 'checkbox'")
            p.label {{ conteudo.label }}
            el-table(:data="conteudo.anexos", :show-header="false")
              //- Coluna de nome
              el-table-column(
                prop="tipo"
              )

              el-table-column(
                prop="label"
              )

              //- Coluna de válidos
              el-table-column(
                prop="isValido"
                align="right",
                width="180"
              )
                template(slot-scope="scope")
                  .action-column
                    el-tooltip.btn-actions(
                      v-if="visualizarDocumentosPDF"
                      effect='dark',
                      :content='verificarTooltip(scope.row)',
                      placement="left"
                    )
                      span
                        el-button.button(
                          v-if="!scope.row.isDocumentoAutenticavel",
                          :disabled="verificarExtensao(scope.row)",
                          @click="abrirDocumento(scope.row)"
                        )
                          font-awesome-icon(icon="eye", size="lg")
                    el-tooltip.btn-actions(
                      effect='dark',
                      content='Baixar Documento',
                      placement="left"
                    )
                      el-button.button(
                        v-if="!scope.row.isDocumentoAutenticavel",
                        @click="emitDownload({id: scope.row.id,nome: scope.row.label, isDocumentoAutenticavel: scope.row.isDocumentoAutenticavel, caminho: scope.row.caminho})"
                      )
                        font-awesome-icon(icon="download", size="lg")
                    el-tooltip.btn-actions(
                      effect='dark',
                      content='Visualizar Documento',
                      placement="left"
                    )
                      el-button.button(
                        v-if="scope.row.isDocumentoAutenticavel",
                        @click="abrirPdf(scope.row)"
                      )
                        font-awesome-icon(icon="eye", size="lg")
                    .valido(v-if="scope.row.isValido")
                      font-awesome-icon(icon="check", size="lg")
                      span &nbsp Válido
                    .invalido(v-else-if="scope.row.isValido === false")
                      font-awesome-icon(icon="times", size="lg")
                      span &nbsp Inválido

          .container-item(v-if="conteudo.tipo === 'anexos'")
            p.label {{ conteudo.label }}

            el-table(:data="conteudo.anexos", :show-header="false")
              //- coluna-tipo
              el-table-column(
                prop="tipo"
              )
              //- Coluna de nome
              el-table-column(
                prop="label"
              )

              //- Coluna do download
              el-table-column(
                align="right"
                width="110"
              )
                template(slot-scope="scope")
                  app-action-button(
                    v-if="scope.row.isDocumentoAutenticavel || isEstadoMA || isAmapa || isEstadoBA"
                    :disabled="isVisualizarDocumentos(scope.row)"
                    :cor="isVisualizarDocumentos(scope.row) ? '#C0C4CC' : '#666666'",
                    :text="isVisualizarDocumentos(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                    icone="eye",
                    fontSize="18",
                    @click="abrirPdf(scope.row)"
                  )
                  app-action-button(
                    v-if="!scope.row.isDocumentoAutenticavel"
                    text='Baixar arquivo',
                    icone="download",
                    fontSize="18",
                    @click="emitDownload({id: scope.row.id,nome: scope.row.label, isDocumentoAutenticavel: scope.row.isDocumentoAutenticavel, caminho: scope.row.caminho})"
                  )

          .container-item(v-if="conteudo.tipo === 'dae'")
            p.label {{ conteudo.label }}

            el-table(:data="conteudo.anexos", :show-header="false")
              //- Coluna de nome
              el-table-column(
                prop="label"
              )

              //- coluna-tipo
              el-table-column(
                align="right"
                prop="tipo"
              )

              //- Coluna do download
              el-table-column(
                align="right"
                width="110"
              )
                template(slot-scope="scope")
                  el-tooltip.item(
                    effect='dark',
                    content='Baixar DAE',
                    placement="left"
                    v-if="scope.row.isDae"
                  )
                    el-button.button(
                      @click="emitDownload({id: scope.row.id,nome: scope.row.id + '.pdf', isDae: scope.row.isDae})"
                    )
                      font-awesome-icon(icon="download", size="lg")

          .container-item(v-if="conteudo.tipo === 'publicacao'")
            p.label {{ conteudo.label }}
            el-table(:data="conteudo.anexos", :show-header="false")
              //- Coluna de nome
              el-table-column(
                prop="label"
              )

              //- Coluna do download
              el-table-column(
                align="right"
                width="110"
              )
                template(slot-scope="scope")
                  el-tooltip.item(
                    effect='dark',
                    content='Baixar arquivo',
                    placement="left"
                  )
                    el-button.button(@click="emitDownload({id: scope.row.id, nome: scope.row.label, isDocumentoAutenticavel: scope.row.isDocumentoAutenticavel})")
                      font-awesome-icon(icon="download", size="lg")

          .container-item(v-if="conteudo.tipo === 'portaria'")
            el-button.button(@click="openModal()")
              p.button-modal-label {{ conteudo.label }}
        .container-item(v-if="mapasExibidos.includes(indexItem) && subItem.localizacoes && subItem.localizacoes.length > 0")
          app-resumo-mapa(
            :idMapa="'id-mapa-localizacao-' + subItem.id"
            :height="30"
            :localizacoes="subItem.localizacoes.map(item => item.geometry)",
            :isVisualizarCadastro="true"
          )
          .flex-button
            div.btn
              el-button(
                @click="downloadShape(subItem.id)"
              )
                i.fal.fa-download
                | &nbsp Download do shapefile

        .container-item(v-if="subItem.hasConversas")
          el-button.button(@click="openModalConversas(subItem)")
            el-row.button-modal-label
              i.fal.fa-comments-alt
              | &nbsp Ver mensagens
        .container-item(v-if="subItem.hasSolicitacoesInformacao")
          el-button.button(@click="openModalSolicitacoesInformacao(subItem)")
            el-row.button-modal-label
              i.fal.fa-comments-alt
              | &nbsp Ver informações solicitadas
        .container-item(v-if="subItem.hasProtesto")
          el-button.button(@click="openModalProtesto(subItem)")
            el-row.button-modal-label
              i.fal.fa-comments-alt
              | &nbsp Protesto ativo no processo
        .container-item(v-if="item.despachos[0].titulo === 'Emissão de Custas' && isAmapa")
          visualizar-emissao-custas(
            v-if="item.despachos[indexSubItem].emissaoCusta != null"
            :emissaoCusta="item.despachos[indexSubItem].emissaoCusta"
          )
        //- Anotações input
        .container-item(v-if="(showAnotacao && (indexAnotacao === indexSubItem && indexCollapse === indexItem ))")
          p.label Anotações:
          el-input(
            type="textarea"
            v-model="subItem.anotacao"
            @blur="getAnotacao($event, indexItem, indexSubItem)"
          )

        //- Anotações visualizar
        .container-item(v-if="isInserirVisualizarAnotacao() && subItem.anotacao")
        .container-item(v-if="subItem.validacao")
          app-validacao-automatizada(:validacoes="subItem.validacao.validacoes")
        .container-item(v-if="subItem.hasDespachoAutenticavel")
          a.link(@click="visualizarParecerJuridico(subItem.id)") Parecer Jurídico
        .container-item(v-if="subItem.hasExtratoSentenca")
          a.link(@click="visualizarExtratoSentenca(subItem.id)") Extrato de Sentença
        .container-item(v-if="subItem.hasCertidaoArea")
          a.link(@click="visualizarCertidaoArea(subItem.id)") Certidão de Área
  span.text-empty(v-else) Não há informações de despacho deste processo.
  app-modal-nova(v-if="showModal" :showModal="showModal" :titulo="tituloMinuta"  @closeModal="showModal = false" :width="1000" :padding="0")
    template(slot="body")
    template(slot="footer")
      el-button(size="small") Baixar arquivo

</template>
<script>
import { mapActions } from 'vuex'
import AppModalNova from '@/components/AppModalNova'
import AppModalTermoCompromisso from '@/components/AppModalTermoCompromissoVtn'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import AppModalVisualizarVtnRR from '@/screens/analise/components/AppModalVisualizarVTNRR'
import AppModalVisualizarVtnAP from '@/screens/analise/components/AppModalVisualizarVTNAP'
import AppModalListaConversas from '@/screens/relatorios/components/gerais/AppModalListaConversas.vue'
import AppModalListaSolicitacoesInformacao from '@/screens/relatorios/components/gerais/AppModalListaSolicitacoesInformacao.vue'
import AppModalVisualizarProtesto from '@/screens/analise/components/modal/AppModalVisualizarProtesto.vue'
import AppActionButton from '@/components/AppActionButton'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'
import AppValidacaoAutomatizada from '@/components/AppValidacaoAutomatizada'
import VisualizarEmissaoCustas from '@/components/VisualizarEmissaoCustas'
import axios from '@/utils/api'
import utils from '@/utils/utils'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { perfisInserirAnotacao, perfisInserirVisualizarAnotacao } = regrasAnalise.despacho

export default {
  components: {
    AppModalNova,
    AppModalVisualizaPdf,
    AppModalTermoCompromisso,
    AppModalListaConversas,
    AppModalListaSolicitacoesInformacao,
    AppResumoMapa,
    AppModalVisualizarVtnRR,
    AppModalVisualizarVtnAP,
    AppValidacaoAutomatizada,
    AppActionButton,
    AppModalVisualizarProtesto,
    VisualizarEmissaoCustas
  },

  props: {
    data: {
      required: true
    },
    tituloMinuta: {
      type: String,
      required: false
    },
    visualizacao: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      type: [Number, String]
    },
    tipoProcesso: {
      type: String
    }
  },

  data () {
    return {
      isVisualisaProcessoDespacho: false,
      tituloModal: null,
      tipoModal: null,
      conteudoModal: null,
      isProcesso: false,
      showModalVisualizaPdf: false,
      showModalVisualizarTermo: false,
      dataAceiteTermo: null,
      isVTN: false,
      showModal: false,
      showModalConversas: false,
      showModalSolicitacoesInformacao: false,
      showModalProtesto: false,
      solicitacoesInformacao: [],
      conversas: [],
      showAnotacao: false,
      usuario: null,
      mapasExibidos: [],
      isImagem: false,
      tituloDocumento: '',
      showModalVisualizaVTN: false,
      visualizarDocumentosPDF: false,
      errataMinuta: 'Minuta da errata de título',
      protesto: null
    }
  },

  async mounted () {
    this.usuario = await this.getUsuario()
    this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
  },

  computed: {
    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      findConversasByDespacho: 'conversas/findConversasByDespacho',
      findSolicitacoesInformacaoByDespacho: 'conversas/findSolicitacoesInformacaoByDespacho',
      findProtestoByDespacho: 'conversas/findProtestoByDespacho'
    }),
    emitDownload (key) {
      this.$emit('getDownload', key)
    },

    openModal () {
      this.showModal = true
    },

    handleAnotacoes (subIndex, index) {
      this.showAnotacao = !this.showAnotacao
      this.indexAnotacao = subIndex
      this.indexCollapse = index
    },

    async openModalConversas (despacho) {
      this.conversas = await this.findConversasByDespacho(despacho.id)
      this.showModalConversas = true
    },

    async openModalSolicitacoesInformacao (despacho) {
      this.solicitacoesInformacao = await this.findSolicitacoesInformacaoByDespacho(despacho.id)
      this.showModalSolicitacoesInformacao = true
    },

    async openModalProtesto (despacho) {
      this.protesto = await this.findProtestoByDespacho(despacho.id)
      this.showModalProtesto = true
    },

    visualizarResumoVtnAp (subItem) {
      return (subItem.tipo === 'VTN' ||
        (subItem.tipo === 'RESPOSTA_REVISAO' && subItem.acao && subItem.acao.includes('AGUARDANDO_VALIDACAO_VTN'))) &&
        (this.isAmapa)
    },

    visualizarTitulo (idTitulo) {
      this.tipoModal = 'TITULO_CERTIDAO'
      this.tituloModal = this.tituloMinuta
      this.showModalVisualizaPdf = true
      this.conteudoModal = idTitulo
      this.conteudoModal = !this.isAmapa ? idTitulo : this.idProcesso
      this.isProcesso = this.isAmapa
    },

    visualizarRetificacaoTitulo (idTitulo) {
      this.tipoModal = 'MINUTA_ERRATA'
      this.tituloModal = 'Minuta da Errata de Título'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idTitulo
    },

    visualizarOficio () {
      this.tipoModal = 'OFICIO_CCR'
      this.tituloModal = 'Minuta do Ofício'
      this.showModalVisualizaPdf = true
      this.conteudoModal = this.idProcesso
    },

    visualizarTermoDeCompromisso (vtn) {
      this.dataAceiteTermo = vtn.dataAceiteTermo
      this.tipoPagamento = vtn.formaDePagamento
      this.conteudoModal = vtn.idVTN
      this.showModalVisualizarTermo = true
    },

    visualizarVTN (idVTN) {
      this.tituloModal = 'Resumo da VTN'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idVTN
      this.isVTN = true
    },

    visualizarVTNRR () {
      this.tituloModal = 'Resumo da VTN'
      this.showModalVisualizaVTN = true
      this.conteudoModal = this.idProcesso
    },

    visualizarVtnAP () {
      this.tituloModal = 'Resumo da VTN'
      this.showModalVisualizaVTN = true
      this.conteudoModal = this.idProcesso
    },

    visualizarPortaria (idPortaria) {
      this.tipoModal = 'PORTARIA'
      this.tituloModal = 'Portaria'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idPortaria
    },

    visualizarVistoria (pdfVistoria) {
      this.tipoModal = 'RELATORIO_VISTORIA'
      this.tituloModal = 'Relatório de Vistoria'
      this.showModalVisualizaPdf = true
      this.conteudoModal = pdfVistoria.id
    },

    visualizarLaudo (idDespacho) {
      this.tipoModal = 'LAUDO_ANALISE_AUTOMATIZADA'
      this.tituloModal = 'Laudo análise automatizada'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    visualizarLaudoAutomatico (idDespacho) {
      this.tipoModal = 'LAUDO_AUTOMATICO'
      this.tituloModal = 'Laudo análise automatizada'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    visualizarMapaAutomatico (idDespacho) {
      this.tipoModal = 'MAPA_PLANTA'
      this.tituloModal = 'Mapa análise automatizada'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    visualizarReurb (idDespacho) {
      this.tipoModal = 'DOCUMENTO_GABINETE'
      this.tituloModal = 'Despacho unificado REURB'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },
    visualizarParecerJuridico (idDespacho) {
      this.tipoModal = 'PDF_DEPACHO_ASSINATURA'
      this.tituloModal = 'Parecer jurídico'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    visualizarExtratoSentenca (idDespacho) {
      this.isVisualisaProcessoDespacho = true
      this.tipoModal = 'EXTRATO_SENTENCA'
      this.tituloModal = 'Extrato de sentença'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    visualizarCertidaoArea (idDespacho) {
      this.isVisualisaProcessoDespacho = true
      this.tipoModal = 'CERTIDAO_AREA'
      this.tituloModal = 'Certidão de área'
      this.showModalVisualizaPdf = true
      this.conteudoModal = idDespacho
    },

    abrirPdf (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }
      if (!documento.isDocumentoAutenticavel && (this.isEstadoMA || this.isEstadoBA || this.isAmapa)) {
        this.tipoModal = 'DOCUMENTO'
        this.tituloModal = documento.tipo
        this.conteudoModal = documento.id
        this.isImagem = this.abrirImagem(documento)
        this.showModalVisualizaPdf = true
        return
      }
      this.tipoModal = 'DOCUMENTO_AUTENTICAVEL'
      this.tituloModal = documento.tipo
      this.conteudoModal = documento.id
      this.showModalVisualizaPdf = true
    },

    abrirDocumento (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }
      this.tituloModal = 'Visualizar Documento'
      this.tipoModal = 'DOCUMENTO'
      this.conteudoModal = documento.id
      this.showModalVisualizaPdf = true
      this.isImagem = this.abrirImagem(documento)
      this.tituloDocumento = documento.tipo
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },

    closeModalVisualizaVTN () {
      this.showModalVisualizaVTN = false
    },

    closeModalVisualizarTermo () {
      this.showModalVisualizarTermo = false
    },

    closeModalConversas () {
      this.conversas = []
      this.showModalConversas = false
    },

    closeModalSolicitacoesInformacao () {
      this.solicitacoesInformacao = []
      this.showModalSolicitacoesInformacao = false
    },

    closeModalProtesto () {
      this.protesto = null
      this.showModalProtesto = false
    },

    getAnotacao (event, indexItem, indexSubItem) {
      this.$emit('getAnotacao', { value: event.target.value, indexItem: indexItem, indexSubItem: indexSubItem })
    },

    isInserirAnotacao () {
      return perfisInserirAnotacao.includes(this.usuario?.perfilSelecionado.codigo)
    },

    isInserirVisualizarAnotacao () {
      return perfisInserirVisualizarAnotacao.includes(this.usuario?.perfilSelecionado.codigo)
    },

    async downloadShape (idDespacho) {
      await axios({
        method: 'GET',
        url: `despacho/shape/exportar/${idDespacho}`,
        responseType: 'blob'
      })
    },

    async onCollapse (item, indexItem) {
      if (item.despachos.length === 0) {
        item.loading = true
        item.despachos = []
        try {
          item.despachos = await axios({
            method: 'POST',
            url: `despacho/template/byIds`,
            data: item.idsDespachos,
            loader: false
          })
        } finally {
          item.loading = false
        }
      }

      const hasMap = item.despachos.filter(item => item.localizacoes && item.localizacoes.length > 0)
      if (hasMap && hasMap.length > 0) {
        this.mapasExibidos.push(indexItem)
      }
    },

    verificarExtensao (row) {
      let extensao = utils.getExtensionFile(row.label)
      let value

      if (regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        value = false
      } else {
        value = true
      }
      return value
    },

    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.label)
      let isImagem

      if (regrasAnalise.visualizarDocumentosPDF.extensaoImagens.includes(extensao)) {
        isImagem = true
      } else {
        isImagem = false
      }
      return isImagem
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.label)
      return regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    verificarTooltip (row) {
      let extensao = utils.getExtensionFile(row.label)

      if (regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        return 'Visualizar Documento'
      } else {
        return 'Não é possível exibir esse arquivo'
      }
    },
    isVisualizarDocumentos (row) {
      return !(row.isDocumentoAutenticavel || (this.isDocumentoParaVisualizacao(row) && (this.isEstadoMA || this.isEstadoBA || this.isAmapa)))
    }
  }
}
</script>
<style style scoped lang="scss">
.listagem {
  background-color: #87cefa;
}

.text-empty {
  display:flex;
  justify-content: center;
  align-content: center;
  justify-self: center;
  color: black !important;
}

/deep/ .el-collapse-item__header {
  color: rgb(112, 112, 112);
  font-size: 1em;
}

.container-item {
  padding: 10px 0;
}

.label {
  font-weight: bold;
}

.label-subitem {
  padding-top: 10px;
  color: rgb(112, 112, 112);
}

.valido {
  color: #009c66;
  width: 50%;
}

.flex-button {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.invalido {
  color: firebrick;
  width: 50%;
}

.btn-download {
  width: 50%;
}

.button {
  border: none;
  background: none;
  padding: 0;
}

.button-modal-label {
  font-weight: bold;
  color: #009c66 !important;
}

.button-comIcone span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.link {
  margin-left: 30px;
  margin-top: 30px;
  font-size: 16px;
  cursor: pointer;
  color: #009f61;
  &:hover {
    font-weight: bold;
  }
}

.icon-annotation {
  display: flex;
  justify-content: flex-end;
  color: #009c66;
}

.icon-annotation__pointer {
  cursor: pointer;
}

.keep {
  border: solid 0.5px #c1c1c1;
  border-radius: 10px;
  padding: 10px;
  background: #feefc3;
}

.annotation {
  display: flex;
  justify-content: flex-end;
}

.divider {
  position: relative;
  margin: 0px;
}

h2 {
  margin: 0;
}

>>> .el-table__row td .cell  {
  .action-column {
    display: flex;
    justify-content: space-between;
  }
}

.container-loading {
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDespachos.vue